import React from "react";
import { HowItWorks } from "../components/sections/HowItWorks";
import { Seo } from "../components/Seo";
import { RestaurantDemo } from "../components/sections/RestaurantDemo";
import { AIDemoSection } from "../components/sections/AIDemoSection";
import { useI18n } from "../i18n/I18nContext";
import { PoseEagle } from "../components/PoseEagle";
import { Band } from "../components/Band";

export default function HowItWorksPage() {
  const { t } = useI18n();

  return (
    <main className="pt-40 lg:pt-36" data-testid="how-page">
      <Seo k="how" />
      <Band tone="light" className="pb-10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 pb-4 relative">
          <div className="max-w-3xl">
            <div className="eyebrow mb-3">{t.nav.how}</div>
            <h1 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white tracking-tighter">{t.howPage.title}</h1>
            <p className="text-slate-400 mt-4 text-lg max-w-2xl">{t.howPage.sub}</p>
          </div>
          <PoseEagle
            src="/eagle-poses/eagle-how-it-works-guiding.png"
            size={215}
            mobileSize={100}
            entrance="guide"
            testid="how-eagle"
            className="flex justify-end mt-4 md:mt-0 md:absolute md:right-8 lg:right-16 md:bottom-[-40px] md:z-10"
          />
        </div>
      </Band>
      <Band tone="dark"><HowItWorks /></Band>
      <Band tone="light"><RestaurantDemo /></Band>
      <Band tone="dark"><AIDemoSection /></Band>
    </main>
  );
}
